<template>
    <div class="circadianLights_main" :class="{'cn':version == '1'}">
        <div class="circadianLights_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="circadianLights_right">
            <div class="circadianLights_right_top">
                <div class="right_top_l">
                    <el-select v-model="buildId">
                        <el-option
                            v-for="item in buildNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input :placeholder="$t('App.lights.text24')" v-model="keywords" @keyup.native="getLightListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getLightList()"></i>
                    </el-input>
                </div>
            </div>
            <div class="circadianLights_right_main">
                <div class="main_top">
                    <div class="main_top_l">
                        <div class="div1" v-if="domainName != 'plant'"><span>{{$t('App.sideBar.text8')}}</span></div>
                        <div class="div1" v-if="domainName == 'plant'"><span>{{$t('App.sideBar.text24')}}</span></div>
                        <div class="div2">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                            <div class="btn" @click="postDelLight(checkList,'batch')">
                                <i class="iconfont icon-delete"></i>
                                <span>{{$t('App.lights.text1')}}</span>
                            </div>
                            <el-popover
                              placement="bottom"
                              trigger="click"
                              @show="batchBrightnessShowFun"
                              v-model="batchBrightnessShow"
                              popper-class="brightness_slider">
                                <div class="slider_box" :class="{'cn':version == '1'}">
                                    <el-slider v-model="batchBrightness" @change="batchLampLight" :step="1" :min="0" :max="100"></el-slider><span class="text">{{batchBrightness}}%</span>
                                </div>
                                <div class="btn" slot="reference">
                                    <i class="iconfont icon-Brightness"></i>
                                    <span>{{$t('App.lights.text2')}}</span>
                                </div>
                            </el-popover>
                            
                            <el-popover
                              placement="bottom"
                              trigger="click"
                              @show="batchColorShowFun"
                              v-model="batchColorShow"
                              popper-class="color_slider">
                                <div class="slider_box">
                                    <el-slider v-model="batchColor" @change="batchLampColor" :step="1" :min="0" :max="14" :format-tooltip="formatTooltip"></el-slider><span class="text">{{circadianColorArr[batchColor]}}</span>
                                </div>
                                <div class="btn" slot="reference">
                                    <i class="iconfont icon-Colortemperature"></i>
                                    <span>{{$t('App.lights.text3')}}</span>
                                </div>
                            </el-popover>
                            <div class="btn" @click="postReData(checkList)" v-loading="reDataIndex>0">
                                <i class="iconfont icon-refresh"></i>
                                <span>{{$t('App.lights.text4')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="main_top_r">
                        <div class="btn" @click="lightsFun()"><img :src="img_lights_1"><span>{{$t('App.lights.text5')}}</span></div>
                    </div>
                </div>
                <div class="main_cont">
                    <el-checkbox-group v-model="checkList"  @change="handleCheckedCitiesChange">
                            <!-- element-loading-background="rgba(0, 0, 0, 0.5)" -->
                        <el-table
                            ref="lightDataList"
                            v-loading="loading.lightDataList"
                            height="100%"
                            :data="lightDataList">
                            <el-table-column
                                :label="$t('App.lights.text33')"
                                :prop="'index'"
                                header-align="center"
                                align="left"
                                :width="6*remRatio">
                                <template slot-scope="scope">
                                    <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text42')"
                                :prop="'name'"
                                header-align="left"
                                align="left"
                                :show-overflow-tooltip="true"
                                :min-width="6.5*remRatio">
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text43')"
                                :prop="'deviceId'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="6.5*remRatio">
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text29')"
                                :prop="'floor'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="5*remRatio">
                                 <template slot="header" slot-scope="scope">
                                    <div class="floor_header" @click="floorTypeFun(scope)">
                                        <p><span>{{floorName}}</span><i class="el-icon-arrow-down"></i></p>
                                        <el-select v-model="floorId" placeholder="" @change="floorIdChange" ref="floorRef">
                                            <el-option
                                              v-for="item in tableFloorNav"
                                              :key="item.id"
                                              :label="item.name"
                                              :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text30')"
                                :prop="'roomNumber'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="5*remRatio">
                                 <template slot="header" slot-scope="scope">
                                    <div class="floor_header" @click="roomTypeFun(scope)">
                                        <p><span>{{roomName}}</span><i class="el-icon-arrow-down"></i></p>
                                        <el-select v-model="roomId" placeholder="" @change="roomIdChange" ref="roomRef">
                                            <el-option
                                              v-for="item in tableRoomNav"
                                              :key="item.id"
                                              :label="item.number"
                                              :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                v-for="(item) in lightArr"
                                :key="'table_'+item.prop"
                                :prop="item.prop"
                                :label="item.label"
                                :align="item.align?item.align:'center'"
                                :width="item.width"
                                :show-overflow-tooltip="true"
                                :min-width="item.minWidth">
                                    <template slot-scope="scope">
                                        <div v-if="item.type != 1">{{scope.row[item.prop]}}{{item.unit?item.unit:''}}</div>
                                        <div v-if="item.prop == 'online'" class="online">
                                            <i v-if="scope.row.blueStatus=='0'" class="iconfont icon-lanyax" style="color:rgba(163,175,187,1);"></i>
                                            <i v-if="scope.row.blueStatus=='1'" class="iconfont icon-lanyax" :style="{'color': version=='0'?'rgba(5, 207, 171, 1)':'#8266C7'}"></i>
                                            <span>|</span>
                                            <i v-if="scope.row.online=='0'" class="iconfont icon-disconnect" style="color:rgba(163,175,187,1);"></i>
                                            <i v-if="scope.row.online=='1'" class="iconfont icon-connectx" :style="{'color': version=='0'?'rgba(5, 207, 171, 1)':'#8266C7'}"></i>
                                        </div>
                                        <div v-if="item.prop == 'alarmStatus'" class="alarmStatus">
                                            <span :class="'text_'+scope.row[item.prop]" @click="linkToFun('/service',scope.row)">{{scope.row[item.prop]==0?'normal':scope.row.alarmInfo}}<i class="iconfont icon-weixiu1" v-if="scope.row[item.prop] == 1"></i>
                                            </span>
                                        </div>
                                        <div v-if="item.prop == 'brightness'" class="brightness">
                                            <el-input-number :class="{'input_loading':scope.row.brightnessLoading}" v-model="scope.row.brightness_" :min="0" :max="100" :controls="false" @blur="postLampLight(scope.row)"></el-input-number>
                                            <span class="text" :class="{'loading':scope.row.brightnessLoading}">{{scope.row[item.prop]}}%</span>
                                            <el-popover
                                              placement="bottom"
                                              trigger="click"
                                              :disabled="scope.row.brightnessLoading"
                                              popper-class="brightness_slider">
                                                <div class="slider_box" :class="{'cn':version == '1'}">
                                                    <el-slider v-model="scope.row.brightness_" @change="postLampLight(scope.row)" :step="1" :min="0" :max="100"></el-slider><span class="text">{{scope.row.brightness_}}%</span>
                                                </div>
                                                <span class="btn_img" slot="reference" v-loading="scope.row.brightnessLoading">
                                                    <span class="bg"></span>
                                                    <i class="iconfont icon-setting"></i>
                                                </span>
                                            </el-popover>
                                              <!-- v-if="role == '1'" -->
                                            <el-popover
                                              placement="bottom"
                                              trigger="click"
                                              :disabled="scope.row.PlightLoading"
                                              popper-class="light_dg_slider">
                                                <div class="slider_box">
                                                    <p><span class="span">Ch1</span><el-slider v-model="scope.row.Plight_0_" @change="postLightLightStd(scope.row)" :step="1" :min="0" :max="100"></el-slider><span class="text">{{scope.row.Plight_0_}}%</span></p>
                                                    <p><span class="span">Ch2</span><el-slider v-model="scope.row.Plight_1_" @change="postLightLightStd(scope.row)" :step="1" :min="0" :max="100"></el-slider><span class="text">{{scope.row.Plight_1_}}%</span></p>
                                                    <p><span class="span">Ch3</span><el-slider v-model="scope.row.Plight_2_" @change="postLightLightStd(scope.row)" :step="1" :min="0" :max="100"></el-slider><span class="text">{{scope.row.Plight_2_}}%</span></p>
                                                    <p><span class="span">Ch4</span><el-slider v-model="scope.row.Plight_3_" @change="postLightLightStd(scope.row)" :step="1" :min="0" :max="100"></el-slider><span class="text">{{scope.row.Plight_3_}}%</span></p>
                                                    <p><span class="span">Ch5</span><el-slider v-model="scope.row.Plight_4_" @change="postLightLightStd(scope.row)" :step="1" :min="0" :max="100"></el-slider><span class="text">{{scope.row.Plight_4_}}%</span></p>
                                                    <p><span class="span">Ch6</span><el-slider v-model="scope.row.Plight_5_" @change="postLightLightStd(scope.row)" :step="1" :min="0" :max="100"></el-slider><span class="text">{{scope.row.Plight_5_}}%</span></p>
                                                </div>
                                                <span class="light_dg" slot="reference" v-loading="scope.row.PlightLoading">+</span>
                                            </el-popover>
                                        </div>
                                        <!-- v-if="item.prop == 'color'&&(scope.row.model != 0)" -->
                                        <div v-if="item.prop == 'color'" class="color">
                                            <span class="text">{{scope.row[item.prop]}}K</span>
                                            <el-popover
                                              placement="bottom"
                                              trigger="click"
                                              :disabled="scope.row.colorLoading"
                                              popper-class="color_slider">
                                                <div class="slider_box">
                                                    <el-slider v-model="scope.row.color_" @change="postLampColor(scope.row)" :step="1" :min="0" :max="14" :format-tooltip="formatTooltip"></el-slider><span class="text">{{circadianColorArr[scope.row.color_]}}</span>
                                                </div>
                                                <span class="btn_img" slot="reference" v-loading="scope.row.colorLoading">
                                                    <span class="bg"></span>
                                                    <i class="iconfont icon-setting"></i>
                                                </span>
                                            </el-popover>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                align="center"
                                :width="role == 1?12*remRatio:10*remRatio"
                                :label="$t('App.lights.text6')">
                                <template slot-scope="scope">
                                    <span class="btn" @click="editFun(scope.row)" :title="$t('App.lights.text7')">
                                        <i class="iconfont icon-bianji"></i>
                                    </span>
                                    <span class="btn" @click="historySee(scope.row)" :title="$t('App.lights.text8')">
                                        <i class="iconfont icon-history"></i>
                                    </span>
                                    <span class="btn" @click="upgradeFun(scope.row)" :title="$t('App.lights.text9')">
                                        <i class="iconfont icon-gujianbanbenshengji"></i>
                                    </span>
                                    <span class="btn" @click="postDelLight(scope.row,false,0)" :title="$t('App.lights.text1')">
                                        <i class="iconfont icon-delete"></i>
                                    </span>
                                    <span v-if="role == 1" class="btn" @click="postDelLight(scope.row,false,1)" :title="$t('App.lights.text1')">
                                        <i class="iconfont icon-delete" style="color: red"></i>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-checkbox-group>
                    <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加编辑灯 -->
        <div class="lights_wrap scrollbar_style" v-show="lightsTkShowbg">
            <div class="lights_wrap_bg" @click="lightsTkClose()"></div>
            <div class="lights_box" :class="{'lights_tk_show':lightsTkShow}">
                <div class="lights_title">
                    <span class="span1">{{lightTkTitle}}</span>
                    <span class="span2" @click="lightsTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text42')}}</span>
                        <el-input v-model="lightsForm.name" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text57')}}</span>
                        <el-dropdown @command="commandModel" trigger="click" @visible-change="commandHide('dropdown_lights_model')">
                            <span class="span1">{{lightsFormModelName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_lights_model">
                                <el-dropdown-item v-for="item in modelNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==lightsForm.model}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text43')}}</span>
                        <el-input v-model="lightsForm.deviceId" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text58')}}</span>
                        <el-input v-model="lightsForm.gatewayId" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text29')}}</span>
                        <el-dropdown @command="commandFloor" trigger="click" @visible-change="commandHide('dropdown_cir_floor')">
                            <span class="span1">{{lightsFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_cir_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==lightsForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text30')}}</span>
                        <el-dropdown @command="commandRoom" trigger="click" @visible-change="commandHide('dropdown_cir_room')">
                            <span class="span1">{{lightsFormRoomName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_cir_room">
                                <el-dropdown-item v-for="item in roomNav" :command="item" :key="'room'+item.id" :class="{'select':item.id==lightsForm.roomId}">{{item.number}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <template v-if="lightTkTitle == $t('App.circadianLights.text1') ||lightTkTitle == $t('App.circadianLights.text11')">
                        <div class="form_item">
                            <span class="laber">{{$t('App.lights.text11')}}</span>
                            <span>{{software}}</span>
                        </div>
                        <div class="form_item">
                            <span class="laber">{{$t('App.lights.text12')}}</span>
                            <span>{{software}}</span>
                        </div>
                    </template>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveLight()">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
        <!-- 历史数据 -->
        <div class="history_warp scrollbar_style" v-show="historyShowbg">
            <div class="history_warp_bg" @click="historyClose()"></div>
            <div class="history_box" :class="{'history_show':historyShow}">
                <div class="history_top">
                    <span class="span1">{{$t('App.room_light.text8')}}</span>
                    <span class="span2" @click="historyClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="filter_box">
                    <el-select v-model="chartType" placeholder=" " @change="chartTypeChange(chartType)" v-if="networHistoryType == '1'">
                        <el-option
                          v-for="item in chartTypeArr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="timeType2" placeholder=" " @change="timeType2Change(timeType2)">
                        <el-option
                          v-for="item in timeTypeArr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                </div>

                <div class="table_top_box">
                    <div class="box1">
                       <div class="btn" :class="{'select':networHistoryType == '1'}" @click="networHistoryTypeFun('1')">{{$t('App.lights.text15')}}</div>
                       <div class="btn" :class="{'select':networHistoryType == '2'}" @click="networHistoryTypeFun('2')">{{$t('App.lights.text16')}}</div>
                    </div>
                    <div class="download_btn" @click="lampLogList(lightId,timeType2,1)" v-loading="loading.lightDataList2_csv">{{$t('App.lights.text17')}}</div>
                </div>
                <div class="echarts_warp scrollbar_style" v-if="networHistoryType == '1'">
                    <div class="echarts_box echarts_box1">
                        <div class="echarts_top">{{$t('App.lights.text18')}}</div>
                        <div class="history_echarts_box1"></div>
                    </div>
                    <div class="echarts_box echarts_box2">
                        <div class="echarts_top" v-if="domainName != 'plant'">{{$t('App.lights.text19')}}</div>
                        <div class="echarts_top" v-if="domainName == 'plant'">{{$t('App.sideBar.text24')}}</div>
                        <div class="history_echarts_box2"></div>
                    </div>
                </div>
                <div class="table_box" v-if="networHistoryType == '2'">
                    <el-table
                        ref="lightDataList2"
                        v-loading="loading.lightDataList2"
                        element-loading-background="rgba(0, 0, 0, 0.5)"
                        height="100%"
                        :data="lightDataList2">
                        <el-table-column
                            :label="$t('App.lights.text33')"
                            :prop="'webIndex'"
                            align="center"
                            header-align="center"
                            :width="6*remRatio">
                        </el-table-column>
                        <el-table-column
                            v-for="(item) in lightArr2"
                            :key="'table_'+item.prop"
                            :prop="item.prop"
                            :label="item.label"
                            :align="item.align?item.align:'center'"
                            :width="item.width"
                            :show-overflow-tooltip="true"
                            :min-width="item.minWidth">
                            <template slot-scope="scope">
                                <span v-if="item.type != 1">{{scope.row[item.prop]}}{{item.unit?item.unit:''}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange2"
                            @current-change="handleCurrentChange2"
                            :current-page="currentPage2"
                            :page-size="pageSize2"
                            layout="prev, pager, next"
                            :total="total2">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <!-- 网关升级 -->
        <div class="gatewayUpdate_wrap scrollbar_style" v-show="gatewayUpdateTkShowbg">
            <div class="gatewayUpdate_wrap_bg" @click="gatewayUpdateTkClose()"></div>
            <div class="gatewayUpdate_box" :class="{'gateway_tk_show':gatewayUpdateTkShow}">
                <div class="gatewayUpdate_title">
                    <span class="span1">{{$t('App.lights.text20')}}</span>
                    <span class="span2" @click="gatewayUpdateTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="box1">
                   <div><img src="../img/upgrade.png"></div>
                   <div><span>{{gatewayUpdateSoftware}}</span></div>
                </div>
                <p class="p1">{{$t('App.lights.text21')}}</p>
                <div class="btn_box">
                    <div class="btn" v-if="gatewayUpdateType == '1'" @click="gatewayUpdateFun()">{{'Download '+gatewayUpdateVersion}}</div>
                    <el-progress :stroke-width="null" :percentage="uploadGatewayVal" :text-inside="true" v-if="gatewayUpdateType == '2'" v-loading="gatewayUpdateType =='2'"></el-progress>
                    <div class="text" :class="gatewayUpdateStatus=='0'?'span1':'span2'" v-if="gatewayUpdateType == '3'" @click="gatewayUpdateFun()">
                        <span v-if="gatewayUpdateStatus == '0'" class="span1">{{$t('App.lights.text22')}}</span>
                        <span v-if="gatewayUpdateStatus == '1'" class="span2">{{$t('App.lights.text23')}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    // import sideBar from '../components/sideBar.vue'
    import { mapGetters } from 'vuex'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    export default {
        name:'circadianLights',
        data () {
            return{
                buildId:'',
                buildNav:[],
                keywords:'',
                floorNav:[],
                roomNav:[],


                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                lightArr:[],
                lightDataList:[],
                lightDataIdList:[],
                alertsArr:['normal','alerts'],
                onlineArr:['Off-line','On-line'],

                floorName:'Floor',
                floorId:'',
                roomName:'Room',
                roomId:'',
                tableFloorNav:[{id:'',number:''}],
                tableRoomNav:[{id:'',name:''}],

                currentPage:1,
                pageSize:20,
                total:0,

                lightsTkShowbg:false,
                lightsTkShow:false,
                lightsForm:{
                    name:'',
                    deviceId:'',
                    floorId:'',
                    roomId:'',
                    gatewayId:'',
                    model:'',
                    
                    // type:'0',
                },
                modelNav:[{id:'2',name:'WE-CL10'},{id:'3',name:'WE-CL20'}],
                lightsFormFloorName:'',
                lightsFormRoomName:'',
                lightTkTitle:'',
                software:'',
                firmware:'',

                batchBrightness:0,
                batchBrightnessShow:false,
                batchColor:0,
                batchColorShow:false,
                websocket:null,
                clientid:null,
                circadianColorArr:[1200,1500,2000,2500,2700,3000,3500,4000,4500,5000,5500,5700,6000,6300,6500],

                historyShowbg:false,
                historyShow:false,
                networHistoryType:'1',
                chartType:'0',
                chartTypeStr:'line',
                chartTypeArr:[{label:'Line',value:'0',str:'line'},{label:'Bar',value:'1',str:'bar'}],
                timeType1:'0',
                timeType2:'0',
                timeTypeStr:'Daily',
                timeTypeArr:[{label:'Daily',value:'0'},{label:'Weekly',value:'4'},{label:'Monthly',value:'1'},{label:'Yearly',value:'2'}],

                lightDataList2:[],
                lightArr2:[],

                currentPage2:1,
                pageSize2:20,
                total2:0,

                reDataIndex:0,

                loading:{
                    lightDataList:false,
                    lightDataList2:false,
                    lightDataList2_csv:false,
                },

                gatewayUpdateTkShowbg:false,
                gatewayUpdateTkShow:false,
                uploadGatewayVal:0,
                gatewayUpdateType:'1',
                gatewayUpdateSoftware:'',
                gatewayUpdateVersion:'',
                gatewayUpdateStatus:'1',

                img_lights_1:'',
                
                updateRemRatioShakeProof:null,

                delDelIs_true:false,
            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',
                role:'role',
                
                remRatio:'remRatio',
                updateRemRatio:'updateRemRatio',

                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',
                domainName: 'domainName',
            }),
            lightsFormModelName(){
                let name = '';
                for(let d of this.modelNav){
                    if(d.id == this.lightsForm.model){
                        name = d.name
                    }
                }
                return name
            }
        },
        components:{
            // 'sideBar':sideBar
        },
        beforeDestroy(){
            if(this.websocket){
                this.websocket.close();
            }
        },
        mounted(){
            this.img_lights_1 = require('../img/room/map/lights_1.png');

            if(this.version == '1'){
                this.img_lights_1 = require('../img/room/map/lights_1_v1.png');
            }

            this.alertsArr = [this.$t('App.room_light.text59'),this.$t('App.room_light.text60')];
            this.onlineArr = [this.$t('App.room.text65'),this.$t('App.room.text66')];
            this.chartTypeArr = [{label:this.$t('App.room_light.text61'),value:'0',str:'line'},{label:this.$t('App.room_light.text62'),value:'1',str:'bar'}];

            this.timeTypeStr = this.$t('App.room_light.text63');
            this.timeTypeArr = [{label:this.$t('App.room_light.text63'),value:'0'},{label:this.$t('App.room_light.text64'),value:'4'},{label:this.$t('App.room_light.text65'),value:'1'},{label:this.$t('App.room_light.text66'),value:'2'}];

            this.floorName = this.$t('App.room.text29');
            this.roomName = this.$t('App.room.text30');

            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })
            for(let i = 1;i<4;i++){
                let val = i<10?'0'+i:i;
                let id = 72 + i;
                this.$set(this.modelNav,this.modelNav.length,{id:id,name:'IH-DM'+val})
            }
            for(let i = 1;i<4;i++){
                let val = i<10?'0'+i:i;
                let id = 82 + i;
                this.$set(this.modelNav,this.modelNav.length,{id:id,name:'IH-DE'+val})
            }
            for(let i = 1;i<6;i++){
                let val = i<10?'0'+i:i;
                let id = 32 + i;
                this.$set(this.modelNav,this.modelNav.length,{id:id,name:'IH-DL'+val})
            }
            for(let i = 1;i<4;i++){
                let val = i<10?'0'+i:i;
                let id = 42 + i;
                this.$set(this.modelNav,this.modelNav.length,{id:id,name:'IH-PL'+val})
            }
            this.lightArr = [
                {prop:'voltage',label:this.$t('App.lights.text25'),minWidth:5*this.remRatio,unit:'V'},
                {prop:'current',label:this.$t('App.lights.text26'),minWidth:5*this.remRatio,unit:'A'},
                {prop:'brightness',label:this.$t('App.lights.text27'),minWidth:7.5*this.remRatio,type:1},
                {prop:'color',label:this.$t('App.lights.text28'),minWidth:9.5*this.remRatio,type:1},
                {prop:'power',label:this.$t('App.lights.text29'),minWidth:10*this.remRatio,unit:'W'},
                {prop:'online',label:this.$t('App.lights.text30'),minWidth:8*this.remRatio,type:1},
                {prop:'mode_info',label:this.$t('App.lights.text56'),minWidth:8*this.remRatio},
                {prop:'alarmStatus',label:this.$t('App.lights.text31'),minWidth:10*this.remRatio,type:1},
                {prop:'updateTime',label:this.$t('App.lights.text32'),width:10*this.remRatio},
            ];
            this.lightArr2 = [
                {prop:'name',label:this.$t('App.room.text42'),minWidth:9*this.remRatio,unit:''},
                {prop:'light',label:this.$t('App.lights.text27'),minWidth:5*this.remRatio,unit:''},
                {prop:'workTime',label:this.$t('App.lights.text34'),minWidth:9*this.remRatio,unit:''},
                {prop:'voltage',label:this.$t('App.lights.text25'),minWidth:5*this.remRatio,unit:'V'},
                {prop:'current',label:this.$t('App.lights.text26'),minWidth:5*this.remRatio,unit:'A'},
                {prop:'power',label:this.$t('App.lights.text29'),minWidth:10*this.remRatio,unit:'W'},
                {prop:'energyTotal',label:this.$t('App.lights.text57'),minWidth:11*this.remRatio,unit:'wh'},
                {prop:'updateTime',label:this.$t('App.lights.text32'),width:11*this.remRatio,unit:''},
            ];
            this.getBuildNav(()=>{
                if(this.buildNav.length > 0){
                    this.buildId = this.buildNav[0].id;
                    this.tableFloorNav = [{id:'',name:''}];
                    this.getFloorNav(data=>{
                        for(let d of data.data.list){
                            this.tableFloorNav.push(d)
                        }
                    })
                }else{
                    this.buildId = ''
                }
                this.getLightList();
            });
            base.websocket_close(allUrl.websocket.ws,websocket=>{
                // console.log(websocket)
                this.websocket = websocket;
                this.websocket.send('{"type":"cmd"}');
                websocket.onmessage = event => {
                    console.log(JSON.parse(event.data));
                    let data = JSON.parse(event.data)
                    if(data.code == '0000'){
                        if(data.data.status == '1'){
                            this.clientid = data.data.clientid
                        }
                        if(data.data.status == '2'){
                            if(this.domainName == 'plant'){
                                this.$notify({
                                title: data.msg,
                                message: this.$t('App.message.text19_')+data.data.name,
                                type: 'success'
                            });
                            } else {
                                this.$notify({
                                title: data.msg,
                                message: this.$t('App.message.text19')+data.data.name,
                                type: 'success'
                            });
                            }
                            
                            if(data.data.type == 'Dimming'){
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.brightnessLoading = false;
                                        d.brightness = d.brightness_;
                                    }
                                }
                            }
                            if(data.data.type == 'Color'){
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.colorLoading = false;
                                        d.color = parseInt(this.circadianColorArr[d.color_]);
                                    }
                                }
                            }
                            if(data.data.type == 'delete'){
                                this.getLightList();
                            }
                            if(data.data.type == 'string'){
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.Plight_0 = d.Plight_0_;
                                        d.Plight_1 = d.Plight_1_;
                                        d.Plight_2 = d.Plight_2_;
                                        d.Plight_3 = d.Plight_3_;
                                        d.Plight_4 = d.Plight_4_;
                                        d.Plight_5 = d.Plight_5_;
                                        d.PlightLoading = false;
                                    }
                                }
                            }
                            if(data.data.type == 'ref_data'){
                                this.reDataIndex--;
                                if(this.reDataIndex<0){
                                    this.reDataIndex = 0;
                                }
                                this.getLightList();
                            }
                        }
                    }else{
                        this.$alert(data.msg, this.$t('App.message.text1'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        });
                        if(data.data.status == '2'){
                            if(data.data.type == 'Dimming'){
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.brightness_ == d.brightness;
                                        d.brightnessLoading = false;
                                    }
                                }
                            }
                            if(data.data.type == 'Color'){
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.color_ = this.circadianColorArr.indexOf(d.color)>0?this.circadianColorArr.indexOf(d.color):0;
                                        d.colorLoading = false;
                                    }
                                }
                            }
                            if(data.data.type == 'string'){
                                for(let d of this.lightDataList){
                                    if(d.id == data.data.id){
                                        d.Plight_0_ = parseInt(d.Plight_0);
                                        d.Plight_1_ = parseInt(d.Plight_1);
                                        d.Plight_2_ = parseInt(d.Plight_2);
                                        d.Plight_3_ = parseInt(d.Plight_3);
                                        d.Plight_4_ = parseInt(d.Plight_4);
                                        d.Plight_5_ = parseInt(d.Plight_5);
                                        d.PlightLoading = false;
                                    }
                                }
                            }
                        }
                    }
                }
            },this)
        },
        methods:{
            formatTooltip(val){
                return this.circadianColorArr[val];
            },
            linkToFun(val,data){
                if(val == '/service'){
                    if(data.alarmStatus == 1){
                        let disConnectTime = '';
                        if(data.disConnectTime){
                           disConnectTime =  new Date(data.disConnectTime).format("YYYY-mm-dd");
                        }
                        this.$router.push({path:val+'?floorId='+data.floorId+'&roomId='+data.roomId+'&deviceType=1'+'&daysDate='+disConnectTime});
                    }
                }
            },
            gatewayUpdateFun(){
                if(this.gatewayUpdateStatus == '1'||this.gatewayUpdateType == '2'){
                    base.websocket(allUrl.websocket.ws,websocket=>{
                        this.websocket1 = websocket;
                        websocket.send('{"type":"updateNetwork","id":"'+this.lightId+'"}');
                        websocket.onmessage = event => {
                            // console.log(JSON.parse(event.data));
                            let data = JSON.parse(event.data)
                            if(data.code == '0000'){
                                if(data.data.status == '1'){
                                    this.clientid = data.data.clientid
                                    base.ajax_postWs(
                                        allUrl.gateway.updateFire,
                                        {
                                            username:this.username,
                                            client_key:this.client_key,
                                            token:this.token,
                                            id:this.lightId,
                                            type:'1',
                                            clientId:this.clientid,
                                        },
                                        this
                                    )
                                    this.uploadGatewayVal = 0;
                                    this.gatewayUpdateType = '2';
                                }
                                if(data.data.status == '2'){
                                    if(data.data.type == 'updateNetwork'){
                                        this.uploadGatewayVal = data.data.step;
                                        if(this.uploadGatewayVal>=100){
                                            this.gatewayUpdateType = '3';
                                            this.gatewayUpdateStatus = '1';
                                        }
                                    }
                                }
                            }else{
                                this.$alert(data.msg, this.$t('App.message.text1'), {
                                    confirmButtonText: this.$t('App.message.text2'),
                                });
                                if(data.data.status == '2'){
                                    if(data.data.type == 'updateNetwork'){
                                        this.uploadGatewayVal = 0;
                                        this.gatewayUpdateType = '3';
                                        this.gatewayUpdateStatus = '0';
                                    }
                                }
                            }
                        }
                    })
                }
            },
            upgradeFun(obj){
                if(obj.online == 0){
                    this.$notify({
                        message: this.$t('App.message.text9'),
                        type: 'warning'
                    });
                    return
                }
                this.gatewayUpdateTkShowbg = true;
                this.gatewayUpdateSoftware = obj.software;
                this.lightId = obj.id;

                this.gatewayUpdateType = '1';
                this.gatewayUpdateStatus = '1';
                base.ajax_post(
                    allUrl.gateway.checkUpdate,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        id:obj.id,
                        type:'1',
                    },
                    {},
                    data=>{
                        if(data.data.status == '1'){
                            this.gatewayUpdateTkShow = true;
                            this.gatewayUpdateVersion = data.data.version
                        }else{
                            this.gatewayUpdateTkShowbg = false;
                            this.$notify({
                                message: data.data.version+this.$t('App.message.text10'),
                                type: 'success'
                            });
                        }
                    },
                    this,()=>{
                        this.gatewayUpdateTkShowbg = false;
                    }
                )
            },
            gatewayUpdateTkClose(){
                let this_ = this;
                this.gatewayUpdateTkShow = false;
                setTimeout(function(){
                    this_.gatewayUpdateTkShowbg = false;
                },400)
            },

            chartTypeChange(){
                for(let d of this.chartTypeArr){
                    if(d.value == this.chartType){
                        this.chartTypeStr = d.str
                    }
                }
                this.getEnergyConsumption(this.lightId,this.timeType2,data=>{
                    this.echartsFun(data,this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','kWh');
                });
                this.getLightingUseSchedule(this.lightId,this.timeType2,data=>{
                    this.echartsFun(data,this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','H');
                });
            },
            timeType2Change(){
                if(this.networHistoryType == '1'){
                    this.getEnergyConsumption(this.lightId,this.timeType2,data=>{
                        this.echartsFun(data,this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','kWh');
                    });
                    this.getLightingUseSchedule(this.lightId,this.timeType2,data=>{
                        this.echartsFun(data,this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','H');
                    });
                }else{
                    this.lampLogList(this.lightId,this.timeType2,0)
                }
            },
            networHistoryTypeFun(val){
                this.networHistoryType = val;

                if(this.networHistoryType == '1'){
                    this.getEnergyConsumption(this.lightId,this.timeType2,data=>{
                        this.echartsFun(data,this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','kWh');
                    });
                    this.getLightingUseSchedule(this.lightId,this.timeType2,data=>{
                        this.echartsFun(data,this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','H');
                    });
                }else{
                    this.lampLogList(this.lightId,this.timeType2,0)
                }
            },
            lampLogList(devId,dateType,download){
                if(download == '1'){
                    this.loading.lightDataList2_csv = true;
                }else{
                    this.loading.lightDataList2 = true;
                }
                base.ajax_post(
                    allUrl.roomLight.lampLogList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,

                        devId:devId,
                        page:this.currentPage2,
                        count:this.pageSize2,
                        dateType:dateType,
                        // date:date,
                        download:download,
                    },
                    {},
                    data=>{
                        if(download == '1'){
                            this.loading.lightDataList2_csv = false;
                            // var $eleBtn2 = $("#btn2");
                            var $eleForm = $("<form method='get'></form>");
                            $eleForm.attr("action",data.data.url);
                            $(document.body).append($eleForm);
                            //提交表单，实现下载
                            $eleForm.submit();
                        }else{
                            this.loading.lightDataList2 = false;
                            this.lightDataList2 = data.data.list;
                            this.total2 = Number(data.data.total);

                            let i = 1 + (this.currentPage2-1)*this.pageSize2;
                            for(let d of this.lightDataList2){
                                d.webIndex = i;
                                i++;
                            }
                        }
                    },
                    this,()=>{
                        if(download == '1'){
                            this.loading.lightDataList2_csv = false;
                        }else{
                            this.loading.lightDataList2 = false;
                        }
                    }
                )
            },
            getLightingUseSchedule(lightId,timeType,callback){
                base.ajax_post(
                    allUrl.dashboard.lightingUseSchedule,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                        devId:lightId,
                        dateType:timeType,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data.data)
                        }else{
                            this.energyConsumption(data.data)
                        }
                    },
                    this
                )
            },
            getEnergyConsumption(lightId,timeType,callback){
                base.ajax_post(
                    allUrl.dashboard.energyConsumption,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        hotelId:this.hotelId,
                        devId:lightId,
                        dateType:timeType,
                        roomId:this.deviceId == '-1'?this.roomId:null,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data.data)
                        }else{
                            this.energyConsumption(data.data)
                        }
                    },
                    this
                )
            },
            echartsFun(data,type,color,className,unit){
                console.log(data,className)
                this.myChart2 = this.$echarts.init(document.getElementsByClassName(className)[0]);
                this.myChart2.setOption({
                    tooltip:{
                        trigger:'axis',
                        axisPointer:{
                            type : type=='bar'?'shadow':'line',
                            snap:true,
                        },
                        padding:0,
                        formatter: function (params) {
                            // console.log(params)
                            var tls = `<div class="history_echarts_tooltip"><p class="p1"><i style="background-color:${params[0].color}"></i><span class="span1">${params[0].value}</span><span class="span1">${unit}</span></p><p class="p2">${params[0].name}</p></div>`;
                           return tls;
                        },
                    },
                    grid:{
                        top:10,
                        left:40,
                        right:50,
                        bottom:40,
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: type=='bar'?true:false,
                        data: data.timeList,
                        axisTick:{
                            show:false,
                            alignWithLabel: true
                        },
                        axisLine:{
                            show:false
                        },
                        axisLabel:{
                            color:'rgba(163,175,187,1)',
                            fontStyle:'AlibabaPuHuiTiR',
                            fontSize:'1rem',
                        },
                    },
                    yAxis: {
                        type: 'value',
                        nameGap:6,
                        splitNumber:4,
                        axisTick:{
                            show:false,
                        },
                        axisLine:{
                            show:false
                        },
                        splitLine:{
                            lineStyle:{
                                color:'rgba(235,239,242,1)'
                            }
                        },
                        axisLabel:{
                            color:'rgba(163,175,187,1)',
                            fontStyle:'AlibabaPuHuiTiR',
                            fontSize:'1rem',
                        },
                    },
                    series: [{
                        data: data.dataList,
                        type: type,
                        smooth:true,
                        barWidth:type=='bar'?'50%':null,
                        symbol:type=='line'?'none':false,
                        lineStyle:{
                            color:color,
                        },
                        itemStyle:{
                            color:color,
                        },
                        markLine:{
                            data:type=='line'?[{type:'average',name:'平均值'}]:null,
                            lineStyle:{
                                color:'rgba(5,206,171,0.4)',
                                type:'dotted',
                            }
                        }
                    }]
                });
            },
            historyClose(){
                let this_ = this;
                this.historyShow = false;
                setTimeout(function(){
                    this_.historyShowbg = false;
                },400)
            },
            historySee(obj){
                this.lightId = obj.id;
                this.historyShowbg = true;
                this.$nextTick(function(){
                    this.historyShow = true;
                    this.networHistoryType = '1';
                    this.getEnergyConsumption(this.lightId,this.timeType2,data=>{
                        this.echartsFun(data,this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box1','kWh');
                    });
                    this.getLightingUseSchedule(this.lightId,this.timeType2,data=>{
                        this.echartsFun(data,this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box2','H');
                    });
                })
            },
            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            batchBrightnessShowFun(){
                if(this.checkList.length == 0){
                    this.$message({
                      showClose: true,
                      message: this.$t('App.message.text11'),
                      type: 'warning'
                    });
                    this.batchBrightnessShow = false;
                }else{
                    this.batchBrightness = 0;
                }
            },
            /*设备批量调光*/
            batchLampLight(val){
                if(this.checkList.length == 0){
                    this.$message({
                      showClose: true,
                      message: this.$t('App.message.text11'),
                      type: 'warning'
                    });
                }else{
                    let lightId = '';
                    for (let i = this.checkList.length - 1; i >= 0; i--) {
                        for(let d of this.lightDataList){
                            if(d.id == this.checkList[i]){
                                if(d.online==0){
                                    if(domainName == 'plant'){
                                        this.$notify({
                                            message: this.$t('App.message.text19_')+d.name+this.$t('App.message.text13'),
                                            type: 'warning'
                                        });
                                    }else{
                                        this.$notify({
                                            message: this.$t('App.message.text19')+d.name+this.$t('App.message.text13'),
                                            type: 'warning'
                                        });   
                                    }
                                    

                                    this.checkList.splice(this.checkList.indexOf(this.checkList[i]),1);
                                    this.handleCheckedCitiesChange(this.checkList)
                                    this.batchColorShow = false;
                                    return
                                }else if(d.blueStatus==0){
                                    if(domainName == 'plant'){
                                        this.$notify({
                                            message: this.$t('App.message.text19_')+d.name+this.$t('App.message.text14'),
                                            type: 'warning'
                                        });
                                    }else{
                                        this.$notify({
                                            message: this.$t('App.message.text19')+d.name+this.$t('App.message.text14'),
                                            type: 'warning'
                                        });   
                                    }
                                    
                                    this.batchColorShow = false;
                                    this.checkList.splice(this.checkList.indexOf(this.checkList[i]),1);
                                    this.handleCheckedCitiesChange(this.checkList)
                                    return
                                }else{
                                    if(lightId == ''){
                                        lightId = this.checkList[i];
                                    }else{
                                        lightId += ','+this.checkList[i];
                                    }
                                    d.brightnessLoading = true
                                }
                            }
                        }
                    }
                    this.batchBrightnessShow = false;
                    base.ajax_postWs(
                        allUrl.roomLight.lampLightAsy,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            lightId:lightId,
                            light:val,
                            clientId:this.clientid,
                        },
                        this
                    )
                }
            },
            /*设备单独调光*/
            postLampLight(data){
                if(!data.brightnessLoading){
                    if(data.brightness != data.brightness_){
                        if(data.online == 0){
                            this.$notify({
                                message: this.$t('App.message.text9'),
                                type: 'warning'
                            });
                            data.brightness_ = data.brightness;
                        }else if(data.blueStatus==0){
                            this.$notify({
                                message: this.$t('App.message.text15'),
                                type: 'warning'
                            });
                            data.brightness_ = data.brightness;
                        }else{
                            data.brightnessLoading = true;
                            base.ajax_postWs(
                                allUrl.roomLight.lampLightAsy,
                                {
                                    username:this.username,
                                    client_key:this.client_key,
                                    token:this.token,
                                    lightId:data.id,
                                    light:parseInt(data.brightness_),
                                    clientId:this.clientid,
                                },
                                this
                            )
                        }
                    }
                }
            },
            /*设备单通道调光*/
            postLightLightStd(data){
                if(!data.PlightLoading){
                    let isTrue = false;
                    if(data.model == '4'||data.model == '5'||data.model == '6'){
                        isTrue = true;
                    }else{
                        if(data.online == 0){
                            this.$notify({
                                message: this.$t('App.message.text9'),
                                type: 'warning'
                            });
                        }else if(data.blueStatus==0){
                            this.$notify({
                                message: this.$t('App.message.text15'),
                                type: 'warning'
                            });
                        }else{
                            isTrue = true;
                        }
                    }
                    if(isTrue){
                        data.PlightLoading = true;
                        base.ajax_postWs(
                            allUrl.roomLight.lightLightStd,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                lightid:data.id,
                                light_0:parseInt(data.Plight_0_),
                                light_1:parseInt(data.Plight_1_),
                                light_2:parseInt(data.Plight_2_),
                                light_3:parseInt(data.Plight_3_),
                                light_4:parseInt(data.Plight_4_),
                                light_5:parseInt(data.Plight_5_),
                                clientId:this.clientid,
                            },
                            this
                        )
                    }
                }
            },
            batchColorShowFun(){
                if(this.checkList.length == 0){
                    this.$message({
                      showClose: true,
                      message: this.$t('App.message.text11'),
                      type: 'warning'
                    });
                    this.batchColorShow = false;
                }else{
                    this.batchColor = 0;
                }
            },
            /*设备批量色温*/
            batchLampColor(val){
                if(this.checkList.length == 0){
                    this.$message({
                      showClose: true,
                      message: this.$t('App.message.text11'),
                      type: 'warning'
                    });
                }else{
                    let lightId = '';
                    for (let i = this.checkList.length - 1; i >= 0; i--) {
                        for(let d of this.lightDataList){
                            if(d.id == this.checkList[i]){
                                if(d.online==0){
                                    if(domainName == 'plant'){
                                        this.$notify({
                                            message: this.$t('App.message.text19_')+d.name+this.$t('App.message.text13'),
                                            type: 'warning'
                                        });
                                    }else{
                                        this.$notify({
                                            message: this.$t('App.message.text19')+d.name+this.$t('App.message.text13'),
                                            type: 'warning'
                                        });
                                    }
                                    
                                    this.checkList.splice(this.checkList.indexOf(this.checkList[i]),1);
                                    this.batchColorShow = false;
                                    this.handleCheckedCitiesChange(this.checkList)
                                    return
                                }else if(d.blueStatus==0){
                                    if(domainName == 'plant'){
                                        this.$notify({
                                            message: this.$t('App.message.text19_')+d.name+this.$t('App.message.text14'),
                                            type: 'warning'
                                        });
                                    }else{
                                        this.$notify({
                                            message: this.$t('App.message.text19')+d.name+this.$t('App.message.text14'),
                                            type: 'warning'
                                        });
                                    }
                                    
                                    this.batchColorShow = false;
                                    this.checkList.splice(this.checkList.indexOf(this.checkList[i]),1);
                                    this.handleCheckedCitiesChange(this.checkList)
                                    return
                                }else{
                                    if(lightId == ''){
                                        lightId = this.checkList[i];
                                    }else{
                                        lightId += ','+this.checkList[i];
                                    }
                                    d.colorLoading = true
                                }
                            }
                        }
                    }
                    this.batchColorShow = false;
                    base.ajax_postWs(
                        allUrl.roomLight.lampColorAsy,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            color:parseInt(this.circadianColorArr[val]),
                            lightId:lightId,
                            clientId:this.clientid,
                        },
                        this
                    )
                }
            },
            /*设备单独调色温*/
            postLampColor(data){
                if(!data.colorLoading){
                    if(data.online == 0){
                        this.$notify({
                            message: this.$t('App.message.text9'),
                            type: 'warning'
                        });
                    }else if(data.blueStatus==0){
                        this.$notify({
                            message: this.$t('App.message.text15'),
                            type: 'warning'
                        });
                    }else{
                        if(parseInt(data.color) != this.circadianColorArr[data.color_]){
                            data.colorLoading = true;
                            base.ajax_postWs(
                                allUrl.roomLight.lampColorAsy,
                                {
                                    username:this.username,
                                    client_key:this.client_key,
                                    token:this.token,
                                    lightId:data.id,
                                    color:parseInt(this.circadianColorArr[data.color_]),
                                    clientId:this.clientid,
                                },
                                this
                            )
                        }
                    }
                }
            },
            floorTypeFun(){
                this.$refs.floorRef.selectOption()
            },
            roomTypeFun(){
                this.$refs.roomRef.selectOption()
            },
            floorIdChange(val){
                for(let d of this.tableFloorNav){
                    console.log(val,d.id)
                    if(d.id == val){
                        this.$set(this,'floorName',d.name)
                        console.log(this.floorName)
                    }
                }
                if(val == ''){
                    this.floorName = 'Floor'
                }
                this.tableRoomNav = [{id:'',name:''}];
                if(this.floorId){
                    this.getRoomNav(this.floorId,data=>{
                        for(let d of data.data.list){
                            this.tableRoomNav.push(d)
                        }
                    })
                }
                this.currentPage = 1;
                this.getLightList();
            },
            roomIdChange(val){
                for(let d of this.tableRoomNav){
                    console.log(d.id,val)
                    if(d.id == val){
                        this.$set(this,'roomName',d.number)
                        console.log(this.roomName)
                    }
                }
                if(val == ''){
                    this.roomName = 'Room'
                }
                this.currentPage = 1;
                this.getLightList();
            },
            /*编辑设备*/
            editFun(item){
                if(this.domainName != 'plant') {
                    this.lightTkTitle = this.$t('App.circadianLights.text1');
                } else {
                    this.lightTkTitle = this.$t('App.circadianLights.text11');
                }
                
                this.lightsTkShowbg = true;
                for(let key in this.lightsForm){
                    this.lightsForm[key] = item[key];
                }
                this.software = item.software;
                this.firmware = item.firmware;
                if(!this.lightsForm.gatewayId){
                    this.lightsForm.gatewayId = '00000000'
                }
                this.lightId = item.id;
                this.getFloorNav(data=>{
                    this.floorNav = data.data.list;
                    for(let d of this.floorNav){
                        console.log(d,d.id,this.lightsForm.floorId)
                        if(d.id == this.lightsForm.floorId){
                            this.lightsFormFloorName = d.name;
                        }
                    }
                })
                this.getRoomNav(this.lightsForm.floorId,data=>{
                    this.roomNav = data.data.list;
                    for(let d of this.roomNav){
                        console.log(d,this.lightsForm.roomId)
                        if(d.id == this.lightsForm.roomId){
                            this.lightsFormRoomName = d.number;
                        }
                    }
                });
                this.$nextTick(function(){
                    this.lightsTkShow = true;
                })
            },
            getGatewayList(callback){
                if(this.buildId){
                    this.loading.gatewayDataList = true;
                    base.ajax_post(
                        allUrl.gateway.getlist,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            // roomId:this.roomId,
                            page:1,
                            count:10,
                            type:'0',
                            // keywords:this.keywords,
                        },
                        {},
                        data=>{
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*添加设备*/
            lightsFun(){
                if(this.domainName == 'plant') {
                    this.lightTkTitle = this.$t('App.circadianLights.text12');
                } else {
                    this.lightTkTitle = this.$t('App.circadianLights.text2');
                }
                this.lightsTkShowbg = true;
                for(let key in this.lightsForm){
                    this.lightsForm[key] = '';
                }
                this.getGatewayList(data=>{
                    if(data.data.list.length>0){
                        this.lightsForm.gatewayId = data.data.list[0].gatewayId;
                    }
                })
                // this.lightsForm.model = 0;
                this.lightsFormFloorName = '';
                this.lightsFormRoomName = '';
                this.lightId = '0';
                this.getFloorNav(data=>{
                    this.floorNav = data.data.list;
                    if(this.floorNav.length > 0){
                        this.lightsForm.floorId = this.floorNav[0].id;
                        for(let d of this.floorNav){
                            if(d.id == this.lightsForm.floorId){
                                this.lightsFormFloorName = d.name;
                            }
                        }
                        this.getRoomNav(this.lightsForm.floorId,data=>{
                            this.roomNav = data.data.list;
                            if(this.roomNav.length > 0){
                                this.lightsForm.roomId = this.roomNav[0].id;
                                for(let d of this.roomNav){
                                    if(d.id == this.lightsForm.roomId){
                                        this.lightsFormRoomName = d.number;
                                    }
                                }
                            }
                        });
                    }
                })
                this.$nextTick(function(){
                    this.lightsTkShow = true;
                })
            },
            lightsTkClose(){
                let this_ = this;
                this.lightsTkShow = false;
                setTimeout(function(){
                    this_.lightsTkShowbg = false;
                },400)
            },
            commandModel(data){
                this.lightsForm.model = data.id;
            },
            commandFloor(data){
                this.lightsForm.floorId = data.id;
                this.lightsFormFloorName = data.name;
                this.getRoomNav(this.lightsForm.floorId,data=>{
                    this.roomNav = data.data.list;
                    this.lightsForm.roomId = '';
                    this.lightsFormRoomName = ''
                });
                this.lightsForm.roomId = '';
            },
            commandRoom(data){
                this.lightsForm.roomId = data.id;
                this.lightsFormRoomName = data.number;
            },
            postSaveLight(){
                let this_ = this;
                base.ajax_post(
                    allUrl.roomLight.saveLight,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        lightId:this.lightId,
                        type:'1',
                        ...this.lightsForm
                    },
                    {},
                    data=>{
                        this.getLightList();
                        this.lightsTkShow = false;
                        setTimeout(function(){
                            this_.lightsTkShowbg = false;
                        },400)
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                    },
                    this
                )
            },
            /*楼房下拉列表*/
            getBuildNav(callback){
                if(this.hotelId){
                    base.ajax_post(
                        allUrl.room.buildNav,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelId,
                        },
                        {},
                        data=>{
                            this.buildNav = data.data.list;
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*楼层下拉列表*/
            getFloorNav(callback){
                base.ajax_post(
                    allUrl.room.floorNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*楼间下拉列表*/
            getRoomNav(floorId,callback){
                base.ajax_post(
                    allUrl.room.roomNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        floorId:floorId,
                    },
                    {},
                    data=>{
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*设备数据刷新*/
            postReData(arr){
                if(this.reDataIndex>0){
                    return
                }
                let lightId = '',isTrue = true;
                if(arr.length == 0){
                    isTrue = false;
                    this.$message({
                        message: this.$t('App.message.text11'),
                        type: 'warning'
                    });
                }else{
                    this.reDataIndex  = 0;
                    for(let id of arr){
                        if(lightId == ''){
                            lightId = id;
                        }else{
                            lightId += ','+id;
                        }
                        this.reDataIndex++;
                    }
                }
                if(isTrue){
                    base.ajax_postWs(
                        allUrl.roomLight.reData,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            id:lightId,
                            clientId:this.clientid,
                            type:1,
                        },
                        this
                    )
                }
            },
            /*删除设备*/
            postDelLight(obj,type,delDelIs_true){
                let lightId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                        message: this.$t('App.message.text11'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(lightId == ''){
                                lightId = id;
                            }else{
                                lightId += ','+id;
                            }
                        }
                    }
                }else{
                    lightId = obj.id;
                    this.delDelIs_true = delDelIs_true
                }
                if(isTrue){
                    this.$confirm(
                        delDelIs_true==1?this.$t('App.message.delDevText'):this.$t('App.message.text16'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_postWs(
                            allUrl.roomLight.delLight,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                lightId:lightId,
                                clientId:this.clientid,
                                is_true:this.delDelIs_true
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            /*设备列表*/
            getLightListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getLightList();
                }
            },
            getLightList(callback){
                if(this.buildId){
                    this.loading.lightDataList = true;
                    base.ajax_post(
                        allUrl.roomLight.lightList,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            // roomId:this.roomId,
                            page:this.currentPage,
                            count:this.pageSize,
                            type:'1',
                            keywords:this.keywords,
                            floorId:this.floorId,
                            roomId:this.roomId,
                        },
                        {},
                        data=>{
                            this.lightDataList = data.data.list;
                            this.total = Number(data.data.total);

                            this.loading.lightDataList = false;
                            this.lightDataIdList = [];
                            this.checkList = [];
                            this.isIndeterminate = false;
                            this.checkAll = false;
                            for(let d of this.lightDataList){
                                this.lightDataIdList.push(d.id);
                                this.$set(d,'brightness_',d.brightness);
                                this.$set(d,'color_',this.circadianColorArr.indexOf(d.color)>0?this.circadianColorArr.indexOf(d.color):0);
                                this.$set(d,'brightnessLoading',false);
                                this.$set(d,'colorLoading',false);

                                this.$set(d,'PlightLoading',false);
                                this.$set(d,'Plight_0_',parseInt(d.Plight_0));
                                this.$set(d,'Plight_1_',parseInt(d.Plight_1));
                                this.$set(d,'Plight_2_',parseInt(d.Plight_2));
                                this.$set(d,'Plight_3_',parseInt(d.Plight_3));
                                this.$set(d,'Plight_4_',parseInt(d.Plight_4));
                                this.$set(d,'Plight_5_',parseInt(d.Plight_5));
                            }

                            let i = 1 + (this.currentPage-1)*this.pageSize;
                            for(let d of this.lightDataList){
                                d.webIndex = i;
                                i++;
                            }
                            if(callback){
                                callback(data)
                            }
                            this.$nextTick(function(){
                                this.$refs.lightDataList.doLayout();
                            })
                        },
                        this,()=>{
                            this.loading.lightDataList = false;
                        }
                    )
                }
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.currentPage = 1;
                this.getLightList();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getLightList();
                // console.log(val)
            },
            
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.lampLogList(this.lightId,this.timeType2,0);
            },
            handleCurrentChange2(val) {
                this.currentPage2 = val;
                this.lampLogList(this.lightId,this.timeType2,0);
                // console.log(val)
            },

            handleCheckAllChange(val) {
                this.checkList = val ? JSON.parse(JSON.stringify(this.lightDataIdList)) : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.lightDataIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.lightDataIdList.length;
            },
        },
        watch:{
            hotelId:function(){
                this.getBuildNav(()=>{
                    if(this.buildNav.length > 0){
                        this.buildId = this.buildNav[0].id;
                        this.getFloorNav(data=>{
                            this.tableFloorNav = data.data.list
                        })
                    }else{
                        this.buildId = '';
                    }
                    this.currentPage = 1;
                    this.getLightList();
                });
            },
            buildId:function () {
                this.currentPage = 1;
                this.getLightList();
            },
            updateRemRatio:function(){
                clearTimeout(this.updateRemRatioShakeProof)
                this.updateRemRatioShakeProof = setTimeout(()=>{
                    this.lightArr = [
                        {prop:'voltage',label:this.$t('App.lights.text25'),minWidth:5*this.remRatio,unit:'V'},
                        {prop:'current',label:this.$t('App.lights.text26'),minWidth:5*this.remRatio,unit:'A'},
                        {prop:'brightness',label:this.$t('App.lights.text27'),minWidth:7.5*this.remRatio,type:1},
                        {prop:'color',label:this.$t('App.lights.text28'),minWidth:9.5*this.remRatio,type:1},
                        {prop:'power',label:this.$t('App.lights.text29'),minWidth:10*this.remRatio,unit:'W'},
                        {prop:'online',label:this.$t('App.lights.text30'),minWidth:8*this.remRatio,type:1},
                        {prop:'mode_info',label:this.$t('App.lights.text56'),minWidth:8*this.remRatio},
                        {prop:'alarmStatus',label:this.$t('App.lights.text31'),minWidth:10*this.remRatio,type:1},
                        {prop:'updateTime',label:this.$t('App.lights.text32'),width:10*this.remRatio},
                    ];
                    this.$nextTick(function(){
                        this.$refs.lightDataList.doLayout();
                    })
                },1000);
            }
        }
    }
</script>

<style type="text/css" lang="less">
    .circadianLights_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 50rem;
        // min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .circadianLights_right{
                .circadianLights_right_top .right_top_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .circadianLights_right_main .main_cont{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .history_warp .history_box{
                .table_box .pagination_box .el-pager li{
                    &:hover{
                        color: #513C93;
                        background:rgba(130,102,199,0.1);
                    }
                    &.active{
                        color: #FFFFFF;
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                }
                .table_top_box .box1 .btn.select{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
            }
            .lights_wrap .lights_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
        }
        .circadianLights_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .circadianLights_right{
            position: relative;
            padding: 1.92rem 1.5rem 0;
            width: calc(100% - 11.67rem);
            height: calc(100%);
            .circadianLights_right_top{
                display: flex;
                justify-content: space-between;
                .right_top_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        width: 11.42rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 20rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
            }
            .circadianLights_right_main{
                height: calc(100% - 6.5rem);
                margin-top: 1rem;
                position: relative;
                background: #FFFFFF;
                border: 1px solid #F0F0F0;
                border-radius: 0.4rem;
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 1.67rem 0;
                    .main_top_l{
                        .div1{
                            margin-top: 1.5rem;
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1.5rem;
                            color: #333333;
                        }
                        .div2{
                            margin-top: 1.33rem;
                            display: flex;
                            align-items: center;
                            .btn{
                                margin-left: 1.29rem;
                                display: flex;align-items: center;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                cursor: pointer;
                                i{
                                    font-size:0.8rem;
                                    color: #C6CDD5;
                                }
                                span{
                                    margin-left: 0.5rem;
                                }
                            }
                        }
                    }
                    .main_top_r{
                        margin-top: 2.33rem;
                        display: flex;
                        .btn{
                            margin-left: 1rem;
                            height: 2.5rem;line-height: 2.5rem;
                            padding: 0 1.25rem;
                            background: #FFFFFF;
                            border: 1px solid #F0F0F0;
                            border-radius: 1.25rem;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            img{
                                margin-right: 0.5rem;
                                height: 1rem;
                            }
                        }
                    }
                }
                .main_cont{
                    height: calc(100% - 11rem);
                    margin-top: 0.75rem;
                    .el-checkbox-group{
                        height: 100%;
                    }
                    .el-table{
                        .el-checkbox{
                            margin-left: 1.1rem;
                        }
                        .btn{
                            padding: 0.5rem;
                            cursor: pointer;
                            &+.btn{
                                margin-left: 0.2rem;
                            }
                            i{
                                color: #A3AFBB;
                                font-size:0.8rem;
                            }
                            &:hover{
                                i{
                                    color: #05CFAB;
                                }
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0; 
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                height: 3rem;line-height: 3rem;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                padding: 0;
                            }
                            div{
                                height: 3rem;line-height: 3rem;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .el-loading-spinner{
                            height: 100%;
                            margin-top: 0;top: 50%;
                        }
                        .cell{
                            .el-loading-spinner{
                                height: 100%;
                                margin-top: 0;top: 0;
                                .circular{
                                    width: 1.5rem;height: 1.5rem;
                                }
                            }
                            
                        }
                        .floor_header{
                            width: 100%;
                            position: relative;
                            cursor: pointer;
                            padding: 0;
                            p{
                                background-color: rgba(246,248,250,1);
                            }
                            .el-select{
                                position: absolute;
                                top: 0;
                                left: 0;
                                z-index: -1;
                                width: 100%;
                            }
                            .el-input__inner{
                                height:2.7rem;line-height:2.7rem;
                                border: none;
                                background-color: inherit;

                                font-size:1.1rem;
                                font-weight:500;
                                font-family:PingFang-SC-Medium,PingFang-SC;
                                color:rgba(142,159,175,1);
                            }
                        }
                        .brightness{
                            display: flex;
                            align-items: center;
                            justify-content:flex-end;
                            height: 3rem;
                            .text{
                                // margin-left: auto;
                                position: relative;
                            }
                            input[type=number] {  
                                -moz-appearance:textfield;  
                            }
                            input[type=number]::-webkit-inner-spin-button,  
                            input[type=number]::-webkit-outer-spin-button {  
                                -webkit-appearance: none;  
                                margin: 0;  
                            }
                            >.loading{
                                display: inline-block !important;
                            }
                            >.input_loading{
                                display: none !important;
                            }
                            &:hover{
                                >.text{
                                    display: none;
                                }
                                .el-input-number{
                                    display: inline-block;
                                }
                            }
                            .el-input-number{
                                display: none;
                                .el-input{
                                    height: 2rem;line-height: 2rem;
                                    .el-input__inner{
                                        height: 2rem;line-height: 2rem;
                                        padding: 0;text-align: center;
                                        font-family: AlibabaPuHuiTiR;
                                        font-size: 1rem;
                                        color: #657085;
                                    }
                                } 
                            }
                            .btn_img{
                                display: block;
                                margin-right: auto;
                                margin-left: 0.58rem;
                                margin-right: 0.5rem;
                                width: 1.5rem;height: 1.5rem;line-height: 1.5rem;
                                background: #05CFAB;
                                border-radius: 0.4rem;
                                background-color:rgba(5,207,171,0.4);
                                position: relative;
                                cursor: pointer;
                                i{
                                    color: #FFFFFF;
                                    font-size:0.7rem;
                                    position: relative;z-index: 1;
                                }
                                &:hover{
                                    i{
                                        top: 0.1rem;
                                        font-size: 1rem;
                                    }
                                }
                                .bg{
                                    position: absolute;
                                    width: 100%;height: 100%;
                                    bottom: 0;left: 0;
                                    background-color:rgba(5,207,171,1);
                                    border-radius: 0.4rem;
                                }
                            }
                            .light_dg{
                                display: block;
                                width: 1.5rem;height: 1.5rem;
                                cursor: pointer;
                                background-image: url('../img/room/light_dg_0.png');
                                background-size: 100% 100%;
                                background-position: center;
                                color: rgba(0,0,0,0);
                                &:hover{
                                    background-image: url('../img/room/light_dg_1.png');
                                }
                            }
                        }
                        .color{
                            display: flex;
                            align-items: center;
                            justify-content:center;
                            .text{
                                // margin-left: auto;
                            }
                            .btn_img{
                                display: inline-block;
                                margin-right: auto;
                                margin-left: 0.58rem;
                                width: 1.5rem;height: 1.5rem;line-height: 1.5rem;
                                background: #05CFAB;
                                border-radius: 0.2rem;
                                background-color:rgba(255,190,0,0.4);
                                position: relative;
                                cursor: pointer;
                                i{
                                    color: #FFFFFF;
                                    font-size:0.7rem;
                                    position: relative;z-index: 1;
                                }
                                &:hover{
                                    i{
                                        top: 0.1rem;
                                        font-size: 1rem;
                                    }
                                }
                                .bg{
                                    position: absolute;
                                    width: 100%;height: 100%;
                                    bottom: 0;left: 0;
                                    background-color:rgba(255,190,0,1);
                                }
                            }
                        }
                        .alarmStatus{
                            .text_1{
                                cursor: pointer;
                                color: rgba(255,12,77,1);
                                i{
                                    margin-left: 0.2rem;
                                    font-size: 1rem;
                                }
                            }
                        }
                        .online{
                            width: 4.8rem;
                            height: 1.8rem;
                            line-height: 1.8rem;
                            background: rgba(246,248,250,1);
                            border-radius: 0.67rem;
                            margin: 0 auto;
                            span{
                                position: relative;
                                margin: 0 0.3rem;
                                color:rgba(235, 239, 242, 1);
                            }
                            .iconfont{
                                font-size: 1.2rem;
                            }
                        }
                    }
                    .pagination_box{
                        .el-pagination{
                            float: right;
                            margin-top: 0.5rem;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .lights_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .lights_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .lights_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.lights_tk_show{
                    right: 0rem; 
                }
                .lights_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .history_warp{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .history_warp_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .history_box{
                position: absolute;
                width: 80.42rem;height: 100%;min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -80.42rem;
                transition: all 0.5s;
                &.history_show{
                   right: 0rem; 
                }
                .history_top{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .filter_box{
                    height: 4.3rem;
                    padding: 1.63rem 0 0rem;
                    padding-left: 2.5rem;
                    .el-select{
                        margin-right: 0.83rem
                    }
                    .el-input__inner,.el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-input__inner{
                        border-radius: 1.25rem;
                    }
                }
                .table_top_box{
                    position: relative;
                    .download_btn{
                        position: absolute;
                        right: 3rem;top: 0.12rem;

                        height: 2.5rem;line-height: 2.5rem;
                        padding: 0 1.25rem;
                        background: #FFFFFF;
                        border: 1px solid #F0F0F0;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                    }
                    .box1{
                        display: flex;
                        width: 18.5rem;height: 2.75rem;line-height: 2.75rem;
                        background-color:rgba(246, 248, 250, 1);
                        border-radius:1.38rem;
                        margin: 0.8rem auto 0.8rem;
                        .btn{
                            flex: 1;
                            text-align: center;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(51,51,51,1);
                            cursor: pointer;
                            &.select{
                                background-color:rgba(5, 207, 171, 1);
                                color:rgba(255,255,255,1);
                                border-radius:1.67rem;
                            }
                        }
                    }
                }
                .echarts_warp{
                    height:calc(100%  - 13rem);
                }
                .echarts_box{
                    height: calc(17rem);
                    margin: 0 1.8rem 1.67rem 2.5rem;
                    background: #F6F8F7;
                    border-radius: 5px;
                    .echarts_top{
                        padding-left: 1.67rem;
                        line-height: 2.5rem;
                        font-family: AlibabaPuHuiTiB;
                        font-size: 1rem;
                        color: #333333;
                    }
                    .history_echarts_tooltip{
                        background-color:#fff;
                        padding: 0.3rem 1rem 0.67rem 0;
                        .p1{
                            display: flex;
                            align-items: center;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(51,51,51,1);
                            i{
                                margin-left: 0.92rem;
                                margin-right: 0.5rem;
                                display: inline-block;
                                width: 0.25rem;height: 0.25rem;
                                border-radius: 50%;
                            }
                            .span1{
                                margin-right: 0.3rem;
                            }
                        }
                        .p2{
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(163,175,187,1);
                            padding-left: 1.75rem;
                        }

                    }
                    .history_echarts_box1{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box2{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box3{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box4{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box5{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box6{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box7{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                }
                .table_box{
                    height: calc(100% - 17rem);
                    .el-table{
                        .el-loading-spinner{
                            margin-top: -0.75rem;
                            .circular{
                                width: 1.5rem;height: 1.5rem;
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                height: 3rem;line-height: 3rem;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                            }
                            div{
                                height: 3rem;line-height: 3rem;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .brightness{
                            display: flex;
                            align-items: center;
                            justify-content:flex-end;
                        }
                        .color{
                            display: flex;
                            align-items: center;
                            justify-content:center;
                        }
                        .alarmStatus{
                            .text_1{
                                color: rgba(255,12,77,1);
                                img{
                                    margin-left: 0.2rem;
                                }
                            }   
                        }
                    }
                    .pagination_box{
                        margin-top: 0.5rem;
                        .el-pagination{
                            float: right;
                            // margin-top: 0.5rem;
                            padding:0;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .gatewayUpdate_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .gatewayUpdate_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .gatewayUpdate_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.gateway_tk_show{
                    right: 0rem; 
                }
                .gatewayUpdate_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .box1{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width:calc(100% - 2.5rem);
                    height:5.08rem;
                    margin:2.5rem auto 0;
                    padding: 0 1.5rem;
                    background:rgba(246,248,247,1);
                    img{
                        height: 3rem;
                    }
                    span{
                        font-size:1.67rem;
                        font-family:AlibabaPuHuiTiH;
                        color:rgba(51,51,51,1);
                    }
                }
                .p1{
                    width:calc(100% - 2.5rem);
                    margin:0.75rem auto 0;
                    height:1.42rem;
                    line-height:1.42rem;
                    font-size:1rem;
                    font-family:AlibabaPuHuiTiR;
                    color:rgba(101,112,133,1);
                }
                .btn_box{
                    width:calc(100% - 2.5rem);
                    margin:2rem auto 0;
                    height:2.67rem;
                    background:rgba(5, 207, 171, 0.1);
                    .btn{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        background:rgba(5,207,171,1);
                        border-radius:0.17rem;

                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }
                    .el-progress{
                        .el-loading-mask{
                            background: rgba(255,255,255,0.1);
                        }
                        .el-progress-bar__outer{
                            height: 2.67rem;
                            background-color:initial;
                            border-radius: 0;
                            .el-progress-bar__inner{
                                border-radius: 0;
                                background-color:rgba(5, 207, 171, 1);
                            }
                        }
                    }
                    .text{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        border-radius:0.17rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        &.span1{
                            background-color: rgba(255, 12, 77, 1);
                            cursor:pointer;
                        }
                        &.span2{
                            background-color: rgba(165, 201, 195, 1);
                        }
                    }
                }
            }
        }
    }
</style>